import axios from '@/base/api/axios'
import { toFormData } from '@/utils/utils'

export default {

  async create (series) {
    return convert((await axios.post('/api/activity-series/', await toFormData(serialize(series)))).data)
  },

  async get (seriesId) {
    return convert((await axios.get(`/api/activity-series/${seriesId}/`)).data)
  },

  async listByPlaceId (placeId) {
    return convert((await axios.get('/api/activity-series/', { params: { place: placeId } })).data)
  },

  async save (series) {
    const { id } = series
    return convert((await axios.patch(`/api/activity-series/${id}/`, await toFormData(serialize(series)))).data)
  },

  async checkSave (series) {
    const { id } = series
    return (await axios.patch(`/api/activity-series/${id}/check/`, serialize(series))).data
  },

  delete (seriesId) {
    return axios.delete(`/api/activity-series/${seriesId}/`)
  },
}

export function convert (entry) {
  if (Array.isArray(entry)) {
    return entry.map(convert)
  }
  else {
    return {
      ...entry,
      rule: convertRule(entry.rule),
    }
  }
}

export function serialize (entry) {
  if (entry.rule) {
    return {
      ...entry,
      rule: serializeRule(entry.rule),
    }
  }
  else {
    return entry
  }
}

export function convertRule (rule) {
  // defaults
  const obj = {
    byDay: ['MO'],
    freq: 'WEEKLY',
    isCustom: false,
    custom: rule,
  }
  // takes rule string and returns object
  const parts = rule.split(';')
  if (parts.length > 2 || !rule.includes('FREQ=WEEKLY;BYDAY=')) {
    return {
      ...obj,
      isCustom: true,
    }
  }
  for (const part of parts) {
    if (part.substr(0, 5) === 'BYDAY') {
      obj.byDay = part.substr(6).split(',')
    }
    else if (part.substr(0, 4) === 'FREQ') {
      obj.freq = part.substr(5)
    }
  }
  return obj
}

export function serializeRule (obj) {
  if (obj.isCustom) return obj.custom

  // takes rule object and return string
  return `FREQ=${obj.freq};BYDAY=${obj.byDay.join()}`
}
